import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import cloneDeepWith from 'lodash/fp/cloneDeepWith';
import { config } from '../config';

/**
 * Datadog Logging Configuration
 *
 * Log Retention: Logs are persisted for 15 days. Archived logs older than 15 days
 * can be accessed through Datadog's rehydration feature.
 *
 * Version Indexing: Logs are indexed by widget version for debugging and tracking.
 */

const isLocalhost = () => window.location.hostname === 'localhost';

const tokenStringReplacer = (val: string) => {
    if (val && typeof val.replace === 'function') {
        let sanitizedVal = val.replace(/access_token=[^&]*/, 'access_token=REDACTED');
        sanitizedVal = sanitizedVal.replace(/id_token=[^&]*/, 'id_token=REDACTED');
        return sanitizedVal;
    }
};

const env = config.id === 'env.production' ? 'prod' : 'staging';
const serviceName = `charging-station-widget${env === 'staging' ? '-dev' : '-prod'}`;

const isExternalResourceError = (message?: string): boolean => {
    if (!message) {
        return false;
    }
    const isNetworkError = message.startsWith('Fetch error') || message.startsWith('XHR error');
    if (!isNetworkError) {
        return false;
    }
    const isOwnDomain = message.includes('smart-route.rio.cloud') || message.includes('api.smart-route');
    return !isOwnDomain;
};

const setupErrorLogger = () => {
    const clientToken = config.datadog.datadog_logs_client_token;
    datadogLogs.init({
        clientToken,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        service: serviceName,
        env,
        beforeSend: log => {
            if (isExternalResourceError(log.message)) {
                return false;
            }
            return cloneDeepWith(tokenStringReplacer, log);
        },
    });
    datadogLogs.setGlobalContextProperty('account_id', config.aws_client_id);
    datadogLogs.setGlobalContextProperty('team', 'MAN Smart Route Planning');
    datadogLogs.setGlobalContextProperty('team_identifier', 'man-team-smart-route-planning');
    datadogLogs.setGlobalContext({ level: 'info' });
};

const setupRealUserMonitoring = () => {
    const applicationId = config.datadog.datadog_rum_app_id;
    const clientToken = config.datadog.datadof_rum_client_token;
    const version = config.build_version; // Logs are indexed by widget version for debugging
    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.eu',
        service: serviceName,
        version,
        env,
        defaultPrivacyLevel: 'mask',
    });

    datadogRum.startSessionReplayRecording();
};

if (!isLocalhost()) {
    setupErrorLogger();
    // Disable datadog rum: We do not use the service and it is very costly to maintain for all users
    // setupRealUserMonitoring();
}
